<section class="context-wrapper">
    <gen-overlay-loader *ngIf="!viewInit" class="contex-wrapper-loader" [showOverlay]="false" [loaderType] = "'SKELETON-PLAIN'"></gen-overlay-loader>
    <section class="context-wrapper-data" *ngIf="viewInit">
        <gen-dynamic-form-table
            [formId]="payload.formId"
            [listenToDataChange]="payload.listenToDataChange"
            [tableTitle]="payload.tableTitle"
            [data]="formData || []"
            [formVertical]="payload.formVertical"
            [popupMode]="payload.popupMode"
            [disabled]="payload.disabled || disabled"
            [editMode]="payload.editMode"
            [isExtraRow]="payload.isExtraRow"
            [viewAsTable]="payload?.viewAsTable"
            [tableVertical]="payload?.tableVertical"
            [titleClass]="payload?.tableTitleCssClass"
            [showAddButton]="payload.showAddButton"
            [showDeleteButton]="payload.showDeleteButton"
            (itemUpdateEmitter)="handleUpdateEvent($event)"
            (itemAddEmitter)="addContextToNewItem($event)"
            (itemDeletedEmitter)="deleteItem($event)"
            [canDeleteItemRef]="isItemDeletable.bind(this)"
            [removeItemOnDeleteRef]="shouldRemoveItemOnDelete"
            [itemNgClassRef]="getItemCss.bind(this)"
            [hideTitles]="payload.hideTitles || false">
        </gen-dynamic-form-table>
    </section>
    
  </section>

